// Session-based auth gate for the Step 4 social-post Approval section inside
// the Brand Studio. These credentials are intentionally separate from the main
// /mtnadmin CRM login so that only the approving administrator can review posts.

export const APPROVAL_ADMIN_USERNAME = 'RickyRoseZera';
export const APPROVAL_ADMIN_PASSWORD = 'AlbaniaZeraAdmin';
const STORAGE_KEY = 'zera_approval_admin';

export function isApprovalAdmin(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === 'authenticated';
  } catch {
    return false;
  }
}

export function loginApprovalAdmin(username: string, password: string): boolean {
  if (username === APPROVAL_ADMIN_USERNAME && password === APPROVAL_ADMIN_PASSWORD) {
    try {
      sessionStorage.setItem(STORAGE_KEY, 'authenticated');
    } catch {
      /* ignore */
    }
    return true;
  }
  return false;
}

export function logoutApprovalAdmin(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
